import React, { useState} from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
/* import Navigation from '../Navigation/Navigation'; */
import { useTranslation } from '../../utils/hooks/translateHook';
import "./Contact.css"
 

function ContactUs (){
  /* const [message, setMessage] = useState(""); */
  console.log("ContactUs rendered");
  
  const navigate = useNavigate();
  const t = useTranslation();

  const handleSubmit =  async (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);

    const payload = { 
      name: formData.get("name"),
      lastname: formData.get("lastname"),
      email: formData.get("email"),
      message: formData.get("message"),
    };
    try {
      const res = await fetch (
        "https://myworker.workes.dev/contact",   //cloudflare worker here
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
    );
    if (!res.ok) {
      throw new Error("Failed to send message");
    }
    alert(t("contactSuccess"));
    e.target.reset();
    } catch (err) {
      console.error(err);
      alert(t("contactError"));
    }
  };
  console.log("t:", t);
console.log("t(name):", typeof t === "function" ? t("name") : t?.name);
 
    return (
        <section className="contactus">
            <h1>CONTACT US</h1>
            {/* <div className="contactus-area">VIX ACADEMY Contact</div> */}
            <div className="formContainer">
              <form 
                id="form-request" 
                className="contactForm"
                onSubmit={handleSubmit}>  
                <h2 >Reach us and start planning your Education Journey today!!!</h2>
                <div className="contactForm-container">
                  <div className="formElement-container" >
                    <p className="formElement">{t("name").toUpperCase()} </p> <p><input name="name" type="text" className="input-default" id="firstName" placeholder={t("name")} required/></p>
                  </div>
                  <div className="formElement-container" >
                    <p className="formElement">{t("lastName").toUpperCase()} </p>
                    <p><input name="lastname" type="text" className="input-default" id="lastName" placeholder={t("lastName").toUpperCase()} required/></p>
                  </div>
                  <div className="formElement-container" >
                    <p className="formElement">E-MAIL: </p>
                    <p><input name="email" type="email" className="input-default" id="email" placeholder="E-MAIL" required/></p>
                  </div>
                  <div className="formElement-container elementColumn" >
                    <p className="formElement" style={{marginTop: "10px"}}>{t("message")} </p>
                    <p>
                      <textarea rows={5} name="message" className="input-default" id="message" placeholder={t("messageContent").toUpperCase()} required></textarea>
                    </p>
                  </div>
                  <button type="submit" >{t("send")}</button>

                </div>
              </form>
            </div>
 
        </section>
      )
  }
  




export default ContactUs;